import * as wam from '@tcc/wam';
import { getUserData } from './wam';
import { GetRequestInit } from '../types/request';

const tccHeaders = {
  'x-authenticated-user-id': getUserData() ? getUserData().clientId : null,
  'X-http-caller-id': 'Field-view',
  'X-Tcc-Site': wam.getSiteCode()
};

export function requestGet(path, opts: GetRequestInit = {}) {
  const { headers } = opts;

  return fetch(path, {
    credentials: 'include',
    headers: { ...tccHeaders, ...headers }
  });
}

export function requestPost(path, opts: RequestInit = {}) {
  const { headers, body } = opts;

  return fetch(path, {
    method: 'post',
    credentials: 'include',
    headers: { ...tccHeaders, ...headers },
    body
  });
}